import { Paragraph, Text } from "@/atoms"

import styles from "./ItemCardTemplate.module.scss"

import type { ItemCardTemplateProps } from "."

export const ItemCardTemplate = (props: ItemCardTemplateProps) => {
  const { title, description, descriptionMaxRows = 1, icon } = props
  const tooltip = {
    rootClassName: "root-class-tooltip-antd-ks",
    title: description
  }

  return (
    <div className={styles.container}>
      <div className={styles.icon}>{icon}</div>
      <Text
        ellipsis={{
          tooltip: {
            rootClassName: "root-class-tooltip-antd-ks",
            title: title
          }
        }}
        className={styles.title}
      >
        {title}
      </Text>
      <Paragraph
        ellipsis={{ rows: descriptionMaxRows, tooltip }}
        className={styles.description}
      >
        {description}
      </Paragraph>
    </div>
  )
}
